<template>
  <SingleEntryOrList
    :data-list="getList"
    :single-entry-component-name="singleEntryComponentName"
    :list-entry-component-name="listEntryComponentName"
  />
</template>

<script>
import SingleEntryOrList from './SingleEntryOrList.vue';

export default {
  name: 'DataSelector',
  components: { SingleEntryOrList },
  props: {
    list: {
      type: Array,
      required: true,
    },
    selector: {
      type: Function,
      required: true,
    },
    mapper: {
      type: Function,
      required: false,
    },
    sorter: {
      type: Function,
      required: false,
    },
    singleEntryComponentName: {
      type: String,
      required: false,
      default: 'StandardEntry',
    },
    listEntryComponentName: {
      type: String,
      required: false,
      default: 'StandardEntry',
    },
  },
  computed: {
    getList() {
      return this.list
        .filter(this.selector)
        .sort(this.sorter)
        .map(this.mapper);
    },
  },
};
</script>
